import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {currentBrand} from '../../../../_metronic/helpers/brand'
import {useAuth} from '../../auth'
import {isOnPremisesInstallation} from '../../auth/core/onPremisesAccess'
import {StuffIdSearchPage} from './StuffIdSearchPage'

const searchPage = (
  <>
    <PageTitle>جستجوی شناسه کالا/خدمت</PageTitle>
    <StuffIdSearchPage />
  </>
)

// On stuffid.asatsp.ir every address shows the search (a link such as /?q=کابل keeps its address
// and term); inside the panel it answers /apps/stuffid-management and everything under it.
// The bank's own install looks IDs up in its forms but has no ID page (the user, 2026-10-25).
const StuffidsPage = () => {
  const {currentUser} = useAuth()
  if (isOnPremisesInstallation(currentUser) || currentBrand.key === 'fash') {
    return <Navigate to='/' replace />
  }

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path='stuffids' element={searchPage} />
      </Route>
      <Route index element={searchPage} />
      <Route path='*' element={searchPage} />
    </Routes>
  )
}

export default StuffidsPage
